export const UploadIcon = () => {
    return (
        <svg
            width="18"
            height="21"
            viewBox="0 0 18 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_3551_69802)">
                <path
                    d="M9.88281 1.22559C9.39453 0.737305 8.60156 0.737305 8.11328 1.22559L3.11328 6.22559C2.625 6.71387 2.625 7.50684 3.11328 7.99512C3.60156 8.4834 4.39453 8.4834 4.88281 7.99512L7.75 5.12793V13.3584C7.75 14.0498 8.30859 14.6084 9 14.6084C9.69141 14.6084 10.25 14.0498 10.25 13.3584V5.12793L13.1172 7.99512C13.6055 8.4834 14.3984 8.4834 14.8867 7.99512C15.375 7.50684 15.375 6.71387 14.8867 6.22559L9.88672 1.22559H9.88281ZM2.75 14.6084C2.75 13.917 2.19141 13.3584 1.5 13.3584C0.808594 13.3584 0.25 13.917 0.25 14.6084V17.1084C0.25 19.1787 1.92969 20.8584 4 20.8584H14C16.0703 20.8584 17.75 19.1787 17.75 17.1084V14.6084C17.75 13.917 17.1914 13.3584 16.5 13.3584C15.8086 13.3584 15.25 13.917 15.25 14.6084V17.1084C15.25 17.7998 14.6914 18.3584 14 18.3584H4C3.30859 18.3584 2.75 17.7998 2.75 17.1084V14.6084Z"
                    fill="#333739"
                />
            </g>
            <defs>
                <clipPath id="clip0_3551_69802">
                    <rect
                        width="17.5"
                        height="20"
                        fill="white"
                        transform="translate(0.25 0.857422)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
